import { render } from "./Title.html?vue&type=template&id=f782072a&scoped=true&ts=true"
import script from "./Title.ts?vue&type=script&lang=ts"
export * from "./Title.ts?vue&type=script&lang=ts"

import "./Title.css?vue&type=style&index=0&id=f782072a&scoped=true&lang=css"

import exportComponent from "E:\\yl\\web\\lvxingshibie-backend\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f782072a"]])

export default __exports__